import React from 'react';
import { Badge } from '@components/atoms/Badge';
import { Card } from '@components/atoms/Card';
import { BudgetRequest } from '@models/budget.model';
import { format } from 'date-fns';
import { formatCurrency } from './utils';
import { SmallDocumentList } from '@components/molecules/SmallDocumentList';

interface TaskDetailsCardProps {
  budgetRequest: BudgetRequest;
}

export const TaskDetailsCard: React.FC<TaskDetailsCardProps> = ({
  budgetRequest,
}) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
        Task Details
      </h3>
      <Card className="p-6 bg-amber-200 dark:bg-amber-900/20 h-fit">
        <h4 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
          {budgetRequest.task?.name || 'Bid Request'}
        </h4>

        <div className="space-y-4 mb-4">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Project
            </p>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              {budgetRequest.task?.project?.name || 'N/A'}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Address
            </p>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              {budgetRequest.task?.project?.address || 'N/A'}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Bid Request Status
            </p>
            <div className="mt-1">
              <Badge
                size="sm"
                variant={
                  budgetRequest.status === 'ACTIVE'
                    ? 'primary'
                    : budgetRequest.status === 'COMPLETED'
                      ? 'success'
                      : budgetRequest.status === 'CANCELLED'
                        ? 'error'
                        : 'default'
                }>
                {budgetRequest.status}
              </Badge>
            </div>
          </div>

          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Requested Dates
            </p>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              {format(
                new Date(budgetRequest.requestedStartDate),
                'MMM dd, yyyy',
              )}{' '}
              -{' '}
              {format(new Date(budgetRequest.requestedEndDate), 'MMM dd, yyyy')}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Maximum Budget
            </p>
            <p className="text-sm font-medium text-gray-900 dark:text-white">
              {formatCurrency(budgetRequest.maxBudgetAmount)}
            </p>
          </div>
        </div>

        {budgetRequest.description && (
          <div className="mb-4">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              Description
            </p>
            <p className="text-sm text-gray-900 dark:text-white">
              {budgetRequest.description}
            </p>
          </div>
        )}

        {/* Documents Section */}
        {budgetRequest.documents && budgetRequest.documents.length > 0 && (
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              Attached Documents
            </p>
            <SmallDocumentList
              documents={budgetRequest.documents}
              showDelete={false}
            />
          </div>
        )}
      </Card>
    </div>
  );
};
